// 22.01.19
import { MuiThemeProvider } from "@material-ui/core/styles";
import * as React from "react";
import { Provider } from "react-redux"; // Provider gives all child components access to the store by using connect.
import { ConnectedRouter } from "connected-react-router";
import theme from "./app-theme";
import RouterComponent from "./route";
import { configStore, history } from "./store/config";

import CacheBuster from "./CacheBuster";
import "./App.css";
const store = configStore(); // Initialize the store.

class App extends React.Component<any, any> {
  public render() {
    return (
      <MuiThemeProvider theme={theme}>
        <Provider store={store}>
          <ConnectedRouter history={history}>
            <CacheBuster>
              {(cacheProps: any) => {
                const {
                  loading,
                  isLatestVersion,
                  refreshCacheAndReload,
                } = cacheProps;
                if (loading) {
                  return null;
                }
                if (!loading && !isLatestVersion) {
                  // You can decide how and when you want to force reload
                  refreshCacheAndReload();
                }

                return <RouterComponent />;
              }}
            </CacheBuster>
          </ConnectedRouter>
        </Provider>
      </MuiThemeProvider>
    );
  }
}

export default App;
